export default __webpack_public_path__ + "static/media/ipas-web2.c00c8865.jpg";